// @ts-nocheck
import {ConfEnv} from "../../../config/config";
import publicRequest from "../../../Infra/http/public.request";

export const listGamesService = async (queryString: string = "") => {
  return publicRequest.get(`${ConfEnv.API_URL.GAMES_LIST}${queryString}`);
};
